import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringEnterpriseEvolution() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="2508" id="professional-solar-panel-cleaning" className="relative w-full overflow-hidden bg-background" ref={ref}>
      <div className="grid min-h-[800px] w-full grid-cols-1 lg:grid-cols-2">
        {}
        <div className="relative flex flex-col justify-center bg-white px-6 py-20 sm:px-12 lg:px-20 xl:px-32">
          {}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--primary)_0%,_transparent_40%)] opacity-20 pointer-events-none" />
          
          <div className={`relative z-10 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <h1 className="font-sans text-5xl font-extrabold tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95]">
              Professional{" "}
              <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
                Solar
              </span>{" "}
              Panel Cleaning
            </h1>

            <p className="max-w-lg text-lg text-muted-foreground sm:text-xl leading-relaxed">
              Improve efficiency and keep your solar system performing at its best. 
              We provide expert cleaning services to ensure maximum energy output for your property.
            </p>

            <div className="pt-4">
              <Button asChild size="lg" className="h-14 rounded-full px-10 text-lg font-semibold transition-transform hover:scale-105 bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-lg shadow-primary/20">
                <Link to="/ServicesPage">
                  Request a Quote
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="relative h-[500px] w-full lg:h-auto overflow-hidden bg-secondary">
          <div className={`absolute inset-0 h-full w-full transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`} style={{
          clipPath: "polygon(15% 0, 100% 0, 100% 100%, 0% 100%, 0% 15%)"
        }}>
            <img src="https://brief-horse.websiteshop.au/wp-content/uploads/2026/03/ChatGPT-Image-Mar-14-2026-10_41_30-PM.png" alt="Professional technician cleaning solar panels on a rooftop" className="h-full w-full object-cover object-center grayscale-0" />
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent pointer-events-none" />
          </div>

          {}
          <div className="absolute top-0 left-0 h-full w-full pointer-events-none lg:hidden bg-gradient-to-b from-white to-transparent opacity-40 h-24" />
        </div>
      </div>
    </section>;
}